export default __webpack_public_path__ + "static/media/Deed of Contract_03.0c6c2364.jpg";